import { jsx as _jsx } from "react/jsx-runtime";
export function AgentFilterControls() {
  return /*#__PURE__*/_jsx("div", {
    children: "AgentFilterControls coming soon\u2122"
  });
}